import React, { useState } from 'react';
import { Header } from './components/Header';
import { Dashboard } from './components/Dashboard';
import { TestDetails } from './components/TestDetails';
import { MetricsOverview } from './components/MetricsOverview';
import { StatisticalMatrix } from './components/StatisticalMatrix';
import { AssetAnalysis } from './components/AssetAnalysis';
import { KeyInsights } from './components/KeyInsights';
import { DisclaimerModal } from './components/DisclaimerModal';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      <DisclaimerModal open={showDisclaimer} onClose={() => setShowDisclaimer(false)} data-id="element-1" />
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-2" />
      <main className="w-full max-w-[1440px] mx-auto px-6 lg:px-8 py-8 flex-grow" data-id="element-3">
        <Dashboard timeRange={timeRange} data-id="element-4" />
      </main>
      <footer className="bg-[#101010] text-white py-8 mt-12" data-id="element-5">
        <div className="w-full max-w-[1440px] mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-6">
          <p className="text-sm font-medium" data-id="element-7">Prepared for Lenovo EMEA</p>
          <p className="text-sm text-[#737373] mt-4 md:mt-0" data-id="element-8">
            Lenovo EMEA · Attention Testing
          </p>
        </div>
      </footer>
    </div>;
};